import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Layout
import { Navigation } from "@/components/layout/Navigation";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloatingButton } from "@/components/layout/WhatsAppFloatingButton";
import CookieBanner from "@/components/CookieBanner";

// Homepage Sections
import { HeroSection } from "@/components/sections/HeroSection";
import { ProblemasSection } from "@/components/sections/ProblemasSection";
import { ComoTrabajoSection } from "@/components/sections/ComoTrabajoSection";
import { OfertaSection } from "@/components/sections/OfertaSection";
import { ServiciosSection } from "@/components/sections/ServiciosSection";
import { CasosExitoSection } from "@/components/sections/CasosExitoSection";
import { SobreMiSection } from "@/components/sections/SobreMiSection";
import { CTAFinalSection } from "@/components/sections/CTAFinalSection";
import { SEOLocalSection } from "@/components/sections/SEOLocalSection";
import { SEOAnalistaSection } from "@/components/sections/SEOAnalistaSection";
import { TecnologiasSection } from "@/components/sections/TecnologiasSection";
import { BlogCTASection } from "@/components/sections/BlogCTASection";
import { ContactoSection } from "@/components/sections/ContactoSection";

// Pages
import AvisoLegal from "@/pages/AvisoLegal";
import PoliticaPrivacidad from "@/pages/PoliticaPrivacidad";
import PoliticaCookies from "@/pages/PoliticaCookies";
import AnalisisDatosEmpresas from "@/pages/AnalisisDatosEmpresas";
import BusinessIntelligenceMurcia from "@/pages/BusinessIntelligenceMurcia";
import Blog from "@/pages/Blog";
import BlogArticle1 from "@/pages/BlogArticle1";
import BlogArticle2 from "@/pages/BlogArticle2";
import BlogArticle3 from "@/pages/BlogArticle3";
import BlogArticle4 from "@/pages/BlogArticle4";
import ConsultorDatosMurcia from "@/pages/ConsultorDatosMurcia";
import ConsultorPowerBIMurcia from "@/pages/ConsultorPowerBIMurcia";
import AnalistaDatosMurcia from "@/pages/AnalistaDatosMurcia";
import CalculadoraROI from "@/pages/CalculadoraROI";

// Home Page Component
const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = "Análisis de Datos en Murcia para Empresas | Datyon";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", "Detecto dónde pierde dinero tu empresa y te ayudo a recuperarlo. Diagnóstico en 7 días. Resultados reales para industria, distribución y agroalimentaria en Murcia.");
    }
  }, []);

  useEffect(() => {
    const pathToSection = {
      '/servicios': 'servicios',
      '/contacto': 'contacto',
      '/sobre-mi': 'sobre-mi'
    };
    const sectionId = pathToSection[location.pathname];
    if (sectionId) {
      const el = document.getElementById(sectionId);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    } else if (location.pathname === '/') {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#020617] relative overflow-x-hidden">
      <div className="noise-overlay" />
      <Toaster position="top-right" richColors />
      <Navigation />
      <main>
        <HeroSection />
        <ProblemasSection />
        <ComoTrabajoSection />
        <OfertaSection />
        <ServiciosSection />
        <CasosExitoSection />
        <SobreMiSection />
        <CTAFinalSection />
        <SEOAnalistaSection />
        <TecnologiasSection />
        <SEOLocalSection />
        <BlogCTASection />
        <ContactoSection />
      </main>
      <Footer />
      <WhatsAppFloatingButton />
      <CookieBanner />
    </div>
  );
};

// Main App with Router
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/servicios" element={<HomePage />} />
        <Route path="/sobre-mi" element={<HomePage />} />
        <Route path="/contacto" element={<HomePage />} />
        <Route path="/analisis-datos-empresas" element={<AnalisisDatosEmpresas />} />
        <Route path="/business-intelligence-murcia" element={<BusinessIntelligenceMurcia />} />
        <Route path="/consultor-datos-murcia" element={<ConsultorDatosMurcia />} />
        <Route path="/consultor-power-bi-murcia" element={<ConsultorPowerBIMurcia />} />
        <Route path="/analista-datos-murcia" element={<AnalistaDatosMurcia />} />
        <Route path="/calculadora-roi-power-bi-murcia" element={<CalculadoraROI />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/politica-cookies" element={<PoliticaCookies />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/analisis-datos-empresas-decisiones" element={<BlogArticle1 />} />
        <Route path="/blog/como-saber-si-tu-empresa-pierde-dinero" element={<BlogArticle2 />} />
        <Route path="/blog/que-kpis-medir-empresa-rentable" element={<BlogArticle3 />} />
        <Route path="/blog/problema-stock-rentabilidad-empresas" element={<BlogArticle4 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
